import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import * as _ from 'lodash';
import { RepAssessment, CacheService, ITypeValorationReportBO, ITypeStructureReportBO, ITypeExternalReportBO } from '@mapfre-tech/amap3';
import { map, tap } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})

export class ReportService {

  className = 'ReportService';

  constructor(private http: HttpClient, private cacheService: CacheService) { }

  /*
  * Report Assessment
  */
  getAllReportAssessment(cache = true, cacheKey = "allReportAssessment"): Observable<ITypeValorationReportBO[]> {
    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey) as object as Observable<ITypeValorationReportBO[]>;
    } else {
      const observable = this.http.get<ITypeValorationReportBO[]>(environment.base_URL + "/types-valoration-report").pipe(map((res) => {
      this.cacheService.updateCacheData(res, cacheKey)
      return res;
      }))
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
    }
  }

  newAssessment(assessment: ITypeValorationReportBO) {
    return this.http.post(environment.base_URL + "/types-valoration-report", assessment).pipe(tap(() => this.cacheService.deleteCache('allReportAssessment')))
  }

  updateAssessment(assessment: ITypeValorationReportBO, id: number) {
    return this.http.put(environment.base_URL + `/types-valoration-report/${id}`, assessment).pipe(tap(() => this.cacheService.deleteCache('allReportAssessment')))
  }

  /**
   *  Report sections
   */
  getAllReportSections(cache = true, cacheKey = "allReportSections"): Observable<ITypeStructureReportBO[]> {
    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey) as object as Observable<ITypeStructureReportBO[]>;
    } else {
      const observable = this.http.get<ITypeStructureReportBO[]>(environment.base_URL + "/types-structure-report").pipe(map((res) => {
      this.cacheService.updateCacheData(res, cacheKey)
      return res;
      }))
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
    }
  }

  newReportSection(section: ITypeStructureReportBO) {
    return this.http.post(environment.base_URL + "/types-structure-report", section).pipe(tap(() => this.cacheService.deleteCache('allReportSections')))
  }

  updateReportSection(section: ITypeStructureReportBO, id: number) {
    return this.http.put(environment.base_URL + `/types-structure-report/${id}`, section).pipe(tap(() => this.cacheService.deleteCache('allReportSections')))
  }

  /**
 *  Report Type Extern
 */
  getAllExtRepType(cache = true, cacheKey = "allExtReportType"): Observable<ITypeExternalReportBO[]> {
    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey) as object as Observable<ITypeExternalReportBO[]>;
    } else {
      const observable = this.http.get<ITypeExternalReportBO[]>(environment.base_URL + "/external-report-types").pipe(map((res) => {
      this.cacheService.updateCacheData(res, cacheKey)
      return res;
      }))
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
    }
  }

  newExtRepType(report: ITypeExternalReportBO) {
    return this.http.post(environment.base_URL + "/external-report-types", report)
  }

  updateExtRepType(report: ITypeExternalReportBO, id: number) {
    return this.http.put(environment.base_URL + `/external-report-types/${id}`, report)
  }

}

